import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import useTranslation from "../../i18n/useTranslation";

const SEND_PASSWORD_RESET_EMAIL_MUTATION = gql`
  mutation SendPasswordResetEmail($email: String!) {
    resendPasswordResetEmail(email: $email) {
      success
      errors
    }
  }
`;

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");
    const [sendPasswordResetEmail, { loading }] = useMutation(SEND_PASSWORD_RESET_EMAIL_MUTATION);
    const {t} = useTranslation();

    const handleSubmit = (e) => {
        e.preventDefault();
        sendPasswordResetEmail({
            variables: { email: email }
        }).then((res) => {
            setEmail("");
            if (res.data.resendPasswordResetEmail.success) {
                setStatus("✅ Password reset email has been sent successfully!");
                toast.success("Password reset email sent!", { autoClose: 3000 });
            } else {
                const errors = res.data?.resendPasswordResetEmail?.errors || {};
                const errorMessages = Object.values(errors)
                    .flat()
                    .map((err) => err.message)
                    .join("\n") || "An unknown error occurred.";
                setStatus(`❌ Failed to send password reset email. ${errorMessages}.`);
                toast.error(errorMessages, { autoClose: 3000 });
            }
        }).catch(() => {
            setStatus("⚠️ Something went wrong. Please try again.");
            toast.error("Error sending email. Try again later.");
        });
    };

    return (
        <div style={{
            backgroundColor: "#14151a",
            color: "#ffffff",
            fontFamily: "'Poppins', sans-serif",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflowX: "hidden"
        }}>
            <div className="login-box">
                <div className="card card-outline" style={{
                    backgroundColor: "#1f1f2e",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
                    textAlign: "center"
                }}>
                    {/* Logo */}
                    <div className="card-header text-center">
                        <NavLink to="/">
                            <img
                                src="/dist/img/angeonx-sports.png"
                                alt="AngeonX Sports"
                                className="logo img-fluid"
                                style={{ height: "112px" }}
                            />
                        </NavLink>
                    </div>

                    <p className="login-box-msg" style={{ fontSize: "16px", fontWeight: "500", marginBottom: "20px" }}>
                        {t('forgotPassword.title')}
                    </p>

                    {/* Show status messages */}
                    {status && (
                        <p style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: status.includes("✅") ? "var(--kbs-primary, #00adff)" : "red",
                            marginBottom: "10px"
                        }}>
                            {status}
                        </p>
                    )}

                    {/* Form */}
                    <form onSubmit={handleSubmit}>
                        <div className="input-group mb-3">
                            <input
                                type="email"
                                className="form-control"
                                placeholder={t('auth.email')}
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                required
                                style={{
                                    backgroundColor: "#2e2e38",
                                    color: "#ffffff",
                                    border: "1px solid var(--kbs-primary, #00adff)",
                                    borderRadius: "8px",
                                    padding: "12px",
                                    fontSize: "16px",
                                    outline: "none",
                                    width: "100%",
                                    transition: "all 0.3s ease"
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = "var(--kbs-accent, var(--kbs-primary, #00adff))";
                                    e.target.style.backgroundColor = "#3a3a48";
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = "var(--kbs-primary, #00adff)";
                                    e.target.style.backgroundColor = "#2e2e38";
                                }}
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-block"
                            disabled={loading}
                            style={{
                                backgroundColor: "var(--kbs-primary, #00adff)",
                                color: "#232327",
                                fontSize: "16px",
                                fontWeight: "bold",
                                padding: "10px",
                                borderRadius: "8px",
                                width: "100%",
                                transition: "all 0.3s ease",
                                cursor: "pointer"
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = "var(--kbs-accent, var(--kbs-primary, #00adff))"}
                            onMouseOut={(e) => e.target.style.backgroundColor = "var(--kbs-primary, #00adff)"}
                        >
                            {loading ? t('common.sending') : t('forgotPassword.button')}
                        </button>
                    </form>

                    {/* Back to Log In */}
                    <NavLink to="/login"
                             className="text-center d-block"
                             style={{
                                 color: "var(--kbs-primary, #00adff)",
                                 fontWeight: "bold",
                                 textDecoration: "underline",
                                 fontSize: "14px",
                                 margin: 12
                             }}>
                        {t('common.backToLogin')}
                    </NavLink>

                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
